import React, { useEffect, useMemo, useState } from 'react'
import clsx from 'clsx'
import { parseMentionContent } from './mentionUtils'
import { ensureDepartmentLabels, peekDepartmentLabel } from '../../../utils/userDisplayName'

export interface MentionTextProps {
  content: string
  className?: string
}

function mentionLabel(name: string, userId: string): string {
  const department = peekDepartmentLabel(userId)
  return department ? `${name} (${department})` : name
}

const MentionText: React.FC<MentionTextProps> = ({ content, className }) => {
  const parts = useMemo(() => parseMentionContent(content), [content])
  const mentionIdsKey = useMemo(
    () => parts.filter((part) => part.type === 'mention').map((part) => part.userId).join(','),
    [parts],
  )
  const [tick, setTick] = useState(0)

  useEffect(() => {
    if (!mentionIdsKey) return
    let cancelled = false
    ensureDepartmentLabels(mentionIdsKey.split(',')).then(() => {
      if (!cancelled) setTick((value) => value + 1)
    })
    return () => {
      cancelled = true
    }
  }, [mentionIdsKey])

  return (
    <span className={clsx('whitespace-pre-wrap break-words', className)}>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <React.Fragment key={index}>{part.value}</React.Fragment>
        }
        const label = tick >= 0 ? mentionLabel(part.name, part.userId) : part.name
        return (
          <span
            key={index}
            className="font-medium text-primary-600 dark:text-primary-400"
            title={`@${label}`}
          >
            @{label}
          </span>
        )
      })}
    </span>
  )
}

export default MentionText
